import { render, staticRenderFns } from "./DocHubViewer.vue?vue&type=template&id=fd2ba0ce"
import script from "./DocHubViewer.vue?vue&type=script&lang=js"
export * from "./DocHubViewer.vue?vue&type=script&lang=js"
import style0 from "./DocHubViewer.vue?vue&type=style&index=0&id=fd2ba0ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports